<ion-item lines="none">
  <ion-label><a (click)="openLink(parsedUrl)">{{parsedLabel}}</a></ion-label>
</ion-item>